import React from 'react';
import PropTypes from 'prop-types';
import Container from '../../atoms/Container';
import { BoxProps } from '../../atoms/Box/Box';

const containerContentDefaultPt = ['40px', '70px'];
const containerContentDefaultPb = ['40px', '90px'];
const ContainerContent = ({
  pt = containerContentDefaultPt,
  pb = containerContentDefaultPb,
  ...props
}: BoxProps) => <Container pt={pt} pb={pb} {...props} />;

ContainerContent.propTypes = {
  pt: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
    PropTypes.string,
  ]),
  pb: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.number,
    PropTypes.string,
  ]),
};
export default ContainerContent;
